<template lang="pug">
Modal(ref="dlg" title="Change validation response")
  .ati-group-modal
    .form-group
      p.bold The product of the section has been changed, would you like to apply this products validation response group?
      div.text-center
        button.btn.btn-primary.btn-lg.focus(@click="changeAtiGroup()") Yes
        button.btn.btn-default.btn-lg.ml10(@click="cancel()") No
  div(slot="footer")
</template>

<script>
import miniToastr from 'mini-toastr'
import Modal from '@/components/common/Modal'
import Core from '@/service/apis/Core'

export default {
  props: {
    sectionId: {
      type: Number
    },
    atiGroupId: {
      type: Number
    }
  },
  methods: {
    changeAtiGroup() {
      Core.applyAtiGroup(this.sectionId, this.atiGroupId)
        .then(() => {
          this.$emit('close')
          miniToastr.success('Validation response group was updated')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    open() {
      this.$refs.dlg.open()
    },
    cancel() {
      this.$refs.dlg.close()
      this.$emit('close')
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.ati-group-modal {
  max-width: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/ChangeAtiGroupModal.vue